<script>
export default {
  name: 'MenuBoard',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9009 9.85L21.4909 19.74C21.5109 20.01 21.3809 20.19 21.3109 20.27C21.2309 20.36 21.0609 20.5 20.7809 20.5H18.0509L20.2109 9.85H20.9009ZM22.0009 6L21.9909 6.02C22.0109 6.26 21.9909 6.51 21.9309 6.76L14.5609 20.29C14.3209 21.3 13.4209 22 12.3809 22H20.7809C22.0709 22 23.0909 20.91 22.9909 19.62L22.0009 6Z"
      :fill="color"
    />
    <path
      d="M11.4502 2.24039C11.5502 1.84039 11.3002 1.43039 10.9002 1.33039C10.5002 1.24039 10.0902 1.48039 9.99023 1.88039L9.49023 3.95039H11.0302L11.4502 2.24039Z"
      :fill="color"
    />
    <path
      d="M18.0509 2.20957C18.1409 1.79957 17.8809 1.40957 17.4709 1.31957C17.0709 1.22957 16.6709 1.48957 16.5809 1.89957L16.1309 3.96957H17.6709L18.0509 2.20957Z"
      :fill="color"
    />
    <path
      d="M21.8198 5.33043C21.4898 4.53043 20.7098 3.96043 19.7498 3.96043H17.6698L17.1098 6.55043C17.0298 6.90043 16.7198 7.14043 16.3798 7.14043C16.3298 7.14043 16.2698 7.14043 16.2198 7.12043C15.8198 7.03043 15.5598 6.63043 15.6398 6.23043L16.1298 3.95043H11.0298L10.3998 6.55043C10.3198 6.89043 10.0098 7.12043 9.66975 7.12043C9.60975 7.12043 9.54976 7.11043 9.48975 7.10043C9.08976 7.00043 8.83975 6.60043 8.93975 6.19043L9.47975 3.94043H7.44975C6.46975 3.94043 5.59975 4.58043 5.30975 5.52043L1.09975 19.0704C0.659754 20.5204 1.72975 22.0004 3.23975 22.0004H16.3798C17.4198 22.0004 18.3198 21.3004 18.5598 20.2904L21.9298 6.76043C21.9898 6.51043 22.0098 6.26043 21.9898 6.02043C21.9698 5.78043 21.9198 5.54043 21.8198 5.33043ZM14.6998 16.7504H6.69975C6.28975 16.7504 5.94975 16.4104 5.94975 16.0004C5.94975 15.5904 6.28975 15.2504 6.69975 15.2504H14.6998C15.1098 15.2504 15.4498 15.5904 15.4498 16.0004C15.4498 16.4104 15.1098 16.7504 14.6998 16.7504ZM15.6998 12.7504H7.69975C7.28975 12.7504 6.94975 12.4104 6.94975 12.0004C6.94975 11.5904 7.28975 11.2504 7.69975 11.2504H15.6998C16.1098 11.2504 16.4498 11.5904 16.4498 12.0004C16.4498 12.4104 16.1098 12.7504 15.6998 12.7504Z"
      :fill="color"
    />
  </svg>
</template>
